import { c as _c } from "react/compiler-runtime";
import type { Calendar } from '@newfront-insurance/string-formatters';
import { createCalendar } from '@newfront-insurance/string-formatters';
import { useState } from 'react';
export interface CalendarHook {
  increaseMonth: () => void;
  decreaseMonth: () => void;
  calendar: Calendar;
  setYear: (year: number) => void;
  setMonth: (month: number) => void;
  year: number;
  month: number;
}
interface Options {
  initialVisibleMonth: number;
  initialVisibleYear: number;
}
export function useCalendar(options) {
  const $ = _c(17);
  const {
    initialVisibleMonth,
    initialVisibleYear
  } = options;
  const [visibleYear, setVisibleYear] = useState(initialVisibleYear);
  const [visibleMonth, setVisibleMonth] = useState(initialVisibleMonth);
  let t0;
  if ($[0] !== visibleMonth || $[1] !== visibleYear) {
    t0 = createCalendar({
      month: visibleMonth,
      year: visibleYear
    });
    $[0] = visibleMonth;
    $[1] = visibleYear;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const calendar = t0;
  let t1;
  if ($[3] !== visibleMonth || $[4] !== visibleYear) {
    t1 = function increaseMonth() {
      const nextMonth = visibleMonth + 1;
      if (nextMonth > 12) {
        setVisibleMonth(1);
        setVisibleYear(visibleYear + 1);
      } else {
        setVisibleMonth(nextMonth);
      }
    };
    $[3] = visibleMonth;
    $[4] = visibleYear;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const increaseMonth = t1;
  let t2;
  if ($[6] !== visibleMonth || $[7] !== visibleYear) {
    t2 = function decreaseMonth() {
      const prevMonth = visibleMonth - 1;
      if (prevMonth < 1) {
        setVisibleMonth(12);
        setVisibleYear(visibleYear - 1);
      } else {
        setVisibleMonth(prevMonth);
      }
    };
    $[6] = visibleMonth;
    $[7] = visibleYear;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const decreaseMonth = t2;
  let t3;
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = year => {
      setVisibleYear(year);
    };
    t4 = month => {
      setVisibleMonth(month);
    };
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  let t5;
  if ($[11] !== calendar || $[12] !== decreaseMonth || $[13] !== increaseMonth || $[14] !== visibleMonth || $[15] !== visibleYear) {
    t5 = {
      increaseMonth,
      decreaseMonth,
      calendar,
      year: visibleYear,
      month: visibleMonth,
      setYear: t3,
      setMonth: t4
    };
    $[11] = calendar;
    $[12] = decreaseMonth;
    $[13] = increaseMonth;
    $[14] = visibleMonth;
    $[15] = visibleYear;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}